import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import * as Cookies from "es-cookie";
import { ApolloProvider } from "react-apollo";
import {
  getPendingSubmission,
  syncPendingSubmission,   
} from "./utils/examOfflineStore";

import client from "./apolloClient";

// A finished exam that could not reach the server is kept on the device and
// submitted as soon as the network is back, on whatever page the student is.
const syncOfflineExam = () => {
  if (Cookies.get("studenttoken") != undefined) syncPendingSubmission(client);
};
window.addEventListener("online", syncOfflineExam);
syncOfflineExam();
// Also retry while the browser stays online but the server/DB is down.
setInterval(() => {
  if (getPendingSubmission()) syncOfflineExam();
}, 60000);

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  document.getElementById("root"),
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
